import { render, staticRenderFns } from "./ResetPassword.form.vue?vue&type=template&id=4033475b&scoped=true&lang=pug&"
import script from "./ResetPassword.form.vue?vue&type=script&lang=ts&"
export * from "./ResetPassword.form.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPassword.form.vue?vue&type=style&index=0&id=4033475b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4033475b",
  null
  
)

export default component.exports